import { css, cx } from 'linaria';
import { SaveToPocket } from 'components/item-actions/save-to-pocket';
import { MailIcon } from '@pocket/web-ui';
import { breakpointMediumTablet } from '@pocket/web-ui';
import { SocialButton } from 'components/social-button/social-button';
const saveButton = "s1x0nbb";
const shareContainer = "s1udq1iu";

function buildShareUrl(url, source) {
  return `${url}?utm_source=${source}&utm_medium=social`;
}

function buildEmailUrl(shareUrl, title, excerpt) {
  const builtUrl = buildShareUrl(shareUrl, 'emailsynd');
  const body = excerpt ? `${excerpt} — ${encodeURIComponent(builtUrl)}` : encodeURIComponent(builtUrl);
  return `mailto:?subject=${title}&body=${body}`;
}

export const ArticleActions = function ({
  isAuthenticated,
  onSave = () => {},
  onShare = () => {},
  saveStatus,
  excerpt = '',
  title,
  url,
  className
}) {
  const emailUrl = buildEmailUrl(url, title, excerpt);

  const saveAction = () => onSave(url, 'save-story-side');

  const emailAction = () => {
    onShare('email');
    window.location.href = emailUrl;
  };

  return <div className={cx(shareContainer, className)}>
      <div className="social-actions">
        <div className="pocket-share">
          <SaveToPocket saveAction={saveAction} isAuthenticated={isAuthenticated} saveStatus={saveStatus} hideCopy={true} className={saveButton} id="sidebar" />
        </div>

        <div className="facebook-share">
          <SocialButton network="facebook" onSocialShare={onShare} quote={excerpt} u={buildShareUrl(url, 'fbsynd')} />
        </div>

        <div className="twitter-share">
          <SocialButton network="twitter" onSocialShare={onShare} text={title} via="Pocket" url={buildShareUrl(url, 'twtrsynd')} />
        </div>

        <div className="reddit-share">
          <SocialButton network="reddit" onSocialShare={onShare} title={title} url={buildShareUrl(url, 'redditsynd')} />
        </div>

        <div className="linkedin-share">
          <SocialButton network="linkedin" onSocialShare={onShare} source="Pocket" title={title} summary={excerpt} url={buildShareUrl(url, 'linkedinsynd')} />
        </div>

        <div className="email-share">
          <button data-cy="share-email" onClick={emailAction}>
            <MailIcon />
          </button>
        </div>
      </div>
    </div>;
};

require("./article-actions.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./article-actions.js");